export enum ImportActionsEnum {
  IMPORT_INIT_PAGE = 'IMPORT_INIT_PAGE',
  IMPORT_GET_DATA = 'IMPORT_GET_DATA',
  IMPORT_SET_DATA = 'IMPORT_SET_DATA',
  IMPORT_SET_SEARCH_VALUE = 'IMPORT_SET_SEARCH_VALUE',
  IMPORT_GET_DATA_NEXT_PAGE = 'IMPORT_GET_DATA_NEXT_PAGE',
  IMPORT_SET_ORDER = 'IMPORT_SET_ORDER',
  IMPORT_SET_CURRENT_USER = 'IMPORT_SET_CURRENT_USER',
  IMPORT_REMOVE = 'IMPORT_REMOVE',
  IMPORT_SET_FILTERS = 'IMPORT_SET_FILTERS',
  IMPORT_UPLOAD_FILE = 'IMPORT_UPLOAD_FILE',
  IMPORT_CREATE_TEMPLATE_WITH_FILE = 'IMPORT_CREATE_TEMPLATE_WITH_FILE',
  IMPORT_DOWNLOAD_FILE_BY_TEMPLATE_ID = 'IMPORT_DOWNLOAD_FILE_BY_TEMPLATE_ID',
  IMPORT_DOWNLOAD_WARNINGS_FILE = 'IMPORT_DOWNLOAD_WARNINGS_FILE',
  IMPORT_GET_TEMPLATE = 'IMPORT_GET_TEMPLATE',
  IMPORT_SET_TEMPLATE = 'IMPORT_SET_TEMPLATE',
  IMPORT_SET_KNO_ORGANIZATION_ID = 'IMPORT_SET_KNO_ORGANIZATION_ID',
  IMPORT_SET_KNO_ORGANIZATION_ERVK_ID = 'IMPORT_SET_KNO_ORGANIZATION_ERVK_ID',
  IMPORT_SET_SUPERVISION_TYPE_ERVK_ID = 'IMPORT_SET_SUPERVISION_TYPE_ERVK_ID',
  IMPORT_SET_KNM_TYPE_ID = 'IMPORT_SET_KNM_TYPE_ID',
  IMPORT_SET_SUBJECT_TYPE_ID = 'IMPORT_SET_SUBJECT_TYPE_ID',
  IMPORT_SET_SUBJECT_TYPE_ERVK_ID = 'IMPORT_SET_SUBJECT_TYPE_ERVK_ID',
  IMPORT_RESET_UPLOAD_MODAL_STORE = 'IMPORT_RESET_UPLOAD_MODAL_STORE',
  IMPORT_EXPORT_SIMILARITIES_LIST_BY_PLAN_ID = 'IMPORT_EXPORT_SIMILARITIES_LIST_BY_PLAN_ID',
  IMPORT_SET_PLAN_TYPE = 'IMPORT_SET_PLAN_TYPE',
  IMPORT_SET_FEDERAL_LAW = 'IMPORT_SET_FEDERAL_LAW',
}
